import createSagaMiddleware from '@redux-saga/core';
import {
  createStore,
  compose,
  applyMiddleware,
  combineReducers,
  StoreEnhancer,
} from 'redux';

import login from './login/actions';
import forgotPassword from './forgotPassword/actions';
import resetPassword from './resetPassword/actions';
import apps from './appList/actions';
import rootSaga from '../saga';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const rootReducer = combineReducers({
  login,
  forgotPassword,
  resetPassword,
  apps,
});
const sagaMiddleware = createSagaMiddleware();

const middlewares = [];
const enhancers: StoreEnhancer[] = [];

middlewares.push(sagaMiddleware);

enhancers.push(applyMiddleware(...middlewares));

export type AppState = ReturnType<typeof rootReducer>;

export default createStore(
  rootReducer,
  composeEnhancers(...enhancers) as StoreEnhancer,
);

sagaMiddleware.run(rootSaga);
